import { Dialog } from "construct-ui";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import ModelMappingModel from "../../models/model-mapping/model-mapping.model";
import IMEIBasedSuccessRateModel from "../../models/reports/imei-based-success-rate.model";
import ViewBase from "../view-base.view";

/**
 * Model Mapping add and edit diablog
 * 
 * A page that displays diablog to add and edit model mapping
 * 
 * @author cmc.pbhieu 
 */
export default function ModelMappingAddAndEditDialog() {
  ViewBase.call(this);

  const FORM_ID = 'ModelMappingAddNEditForm';
  const UPDATE_ACTION = 'UPDATE';

  let close = () => { };

  let action = '';
  let isUpdating = false;

  let requestPayload = {};

  let customers = [];

  const handleSubmit = (e) => {
    // Form validation
    if (!this.validateForm(e)) {
      return false;
    }

    this.showLoading();
    ModelMappingModel.manage(requestPayload, action)
      .then((result) => {
        this.showMessage(
          this.getText(result[0].code, result[0].message),
          result[0].transStatus,
          () => { close(true); }
        );
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const getCustomers = () => {
    this.showLoading();

    return IMEIBasedSuccessRateModel.getCustomers()
      .then(result => {
        customers = result;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(this.hideLoading);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.closeDialog) {
        close = vnode.attrs.closeDialog;
      }

      action = vnode.attrs.action;
      requestPayload = vnode.attrs.data;
      isUpdating = action === UPDATE_ACTION;

      getCustomers()
    },
    view: (vnode) => {
      return m(Dialog, {
        class: "cui-dialog-lg",
        isOpen: vnode.attrs.isOpen,
        closeOnOutsideClick: false,
        onClose: () => { vnode.attrs.closeDialog(false) },
        title: isUpdating ? this.getText("LT00000128", "Edit") : this.getText("LT00000058", "Create"),
        content: [
          m("container",
            m(".card",
              m(".card-body",
                m('form.needs-validation.row.g-2[novalidate]', { id: FORM_ID, onsubmit: handleSubmit },
                  m(".col-12.position-relative.mb-4.g-2",
                    m("label.form-label.mandatory[for=customerCode]",
                      this.getText("LT00008046", "Customer")
                    ),
                    m(SingleSelectComponent, {
                      id: "customerCode",
                      items: customers,
                      selectedItem: requestPayload.customerCode,
                      disabled: isUpdating,
                      filterable: true,
                      required: true,
                      keyOnly: true,
                      onSelect: (item) => {
                        requestPayload.customerCode = item;
                      },
                    }),
                    m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                  ),

                  m(".col-12.position-relative.mb-4.g-2",
                    m("label.form-label.mandatory[for=mapKey]",
                      this.getText('LT00001014', 'I/F Model')
                    ),
                    m('input.form-control.form-control-bg[required]', {
                      id: 'mapKey',
                      value: requestPayload.mapKey,
                      disabled: isUpdating,
                      onchange: (e) => { requestPayload.mapKey = e.target.value.trim(); }
                    }),
                    m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                  ),

                  m(".col-12.position-relative.mb-4.g-2",
                    m("label.form-label.mandatory[for=mapAttribute1]", this.getText('LT00001013', 'Samsung Model')),
                    m('input.form-control.form-control-bg[required]', {
                      id: 'mapAttribute1',
                      value: requestPayload.mapAttribute1,
                      onchange: (e) => { requestPayload.mapAttribute1 = e.target.value.trim(); }
                    }),
                    m('.invalid-tooltip', this.getText('LT00000729', 'This field is required'))
                  ),
                  m(".col-md-12.gap-2.d-flex.justify-content-end",
                    m("button.btn.btn-primary[type='submit']", this.getText("LT00000022", "Save")),
                    m("button.btn.btn-white[type='button']", { onclick: () => { close(false) } }, this.getText("LT00000021", "Close"))
                  )
                )),
            )
          ),
          this.getBaseViews(),
        ],
      })
    }
  }
}